import React from "react";
import { Link } from "react-router-dom";

const ProjectCard = (props) => {
  return (
    <div className="project-card-container">
      {props.projects.map((project) => {
        return (
          <Link
            key={project.id}
            className="project-card"
            to={project.link}
            target="_blank"
          >
            <img src={project.image} alt={project.title} />
            <div className="project-card-content">
              <h3>{project.title}</h3>
              <p>{project.subtitle}</p>
            </div>
          </Link>
        );
      })}
    </div>
  );
};

export default ProjectCard;
